const hamburger = document.querySelector('.hamburger');
const navbar = document.querySelector('.navbar__custom');
const navbarList = document.querySelector('.mobileContainer');
const menuCloseLayer = document.querySelector('.menuCloseLayer');

/*-----------------
close menu on click outside
-----------------*/
navbar &&
    menuCloseLayer.addEventListener('click', () => {
        closeMenu();
        menuCloseLayer.style.zIndex = '888';
    });

/*-----------------
toggle menu on hamburger click
-----------------*/
navbar &&
    hamburger.addEventListener('click', () => {
        hamburger.classList.toggle('is-active');
        navbarList.classList.toggle('active');
        menuCloseLayer.classList.toggle('active');
    });

/*-----------------
close menu on scroll
-----------------*/
navbar &&
    window.addEventListener('scroll', () => {
        closeMenu();
    });

/*-----------------
close menu function
-----------------*/
const closeMenu = () => {
    hamburger.classList.remove('is-active');
    navbarList.classList.remove('active');
    menuCloseLayer.classList.remove('active');
};
